import dataTypes from '../../../constants/dataTypes';
import { fieldInputTypes } from '../../../constants/fieldInputTypes';

import { REQUIREMENT_TYPES } from './options';

export const getCreateRequirementTemplateBlockParams = (
  currentMaxOrder,
  requirementType,
  requirementTypeData,
  required = false,
  value = null
) => (
  {
    required,
    order: currentMaxOrder + 1,
    requirement_template_block_properties:
      getRequirementTemplateBlockProperties(requirementType, requirementTypeData, value)
  });

export const getUpdateRequirementTemplateBlockParams = (
  currentOrder,
  requirementType,
  requirementTypeData,
  required = false,
  value = null
) => (
  {
    required,
    order: currentOrder,
    requirement_template_block_properties:
        getRequirementTemplateBlockProperties(requirementType, requirementTypeData, value)
  });

export const getRequirementTemplateBlockProperties = (requirementType, requirementTypeData, value) => {
  switch (requirementType) {
    case REQUIREMENT_TYPES.Policies: {
      const requirementTemplateBlockProperties = requirementTypeData?.properties
        ?? requirementTypeData?.requirementTemplateBlockProperties;
      return requirementTemplateBlockProperties.map(currenRequirementTypeData => ({
        ...currenRequirementTypeData,
        requirement_type: requirementType,
        requirement_id: currenRequirementTypeData.id,
        value: currenRequirementTypeData?.value ?? value
      }), []);
    }

    default:
      return [{
        requirement_type: requirementType,
        requirement_id: requirementTypeData?.id,
        value: requirementTypeData?.value ?? value
      }];
  }
};

/**
 * @param data
 * @param companyId
 * @param setError
 * @param setShowError
 * @return [{}]
 */
export const getPolicyProperties = (data, companyId) => {
  const checkboxProperties = data?.[dataTypes.Boolean] ?? [];

  const monetaryProperties = data?.[dataTypes.Monetary] ?? [];
  const alphanumericProperties = data?.[fieldInputTypes.AlphaNumeric] ?? [];

  const booleanPolicyProperties = checkboxProperties?.reduce((result, currentPropertyField) => [...result, {
    display_name: currentPropertyField.label,
    description: currentPropertyField?.description?.length ? currentPropertyField.description : '',
    companyId,
    data_type: dataTypes.Boolean
  }], []) ?? [];

  const monetaryPolicyProperties = monetaryProperties?.reduce((result, currentPropertyField) => [...result, {
    display_name: currentPropertyField.label,
    description: currentPropertyField?.description?.length ? currentPropertyField.description : '',
    companyId,
    data_type: dataTypes.Monetary
  }], []) ?? [];

  const alphanumericPolicyProperties = alphanumericProperties?.reduce((result, currentPropertyField) => [...result, {
    display_name: currentPropertyField.label,
    description: currentPropertyField?.description?.length ? currentPropertyField.description : '',
    companyId,
    data_type: dataTypes.String
  }], []) ?? [];

  return [...booleanPolicyProperties, ...monetaryPolicyProperties, ...alphanumericPolicyProperties];
};
